import { QuestionCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { Alert, Button, Form, InputNumber, Popconfirm, Popover, Space, Tooltip, Typography, message } from "antd";
import React, { useEffect } from "react";
import BinDTO from "src/models/BinDTO";
import { FormatHeaterOffsetHelpShortText, HeaterSettingsHelpTextTooltip, useSetHeaterMode, useUpdateHeaterMcOffsetMutation } from "./HeaterControls";
import { useBinInfoContext } from "src/queries/BinInfoContext";
import { getDesiredFanMode } from "src/pages/shared/binDTOUtils";
import ManualFanMode from "src/consts/ManualFanMode";

export const HeaterSettingsAdjustmentPopover = (props: React.PropsWithChildren<{ binDTO: BinDTO | null | undefined, disabled?: boolean}>) => {
    const binInfo = useBinInfoContext();
    const updateHeaterMcOffsetMutation = useUpdateHeaterMcOffsetMutation(binInfo.deviceId!);
    const mutateHeaterMode = useSetHeaterMode(binInfo.deviceId!);

    const [form] = Form.useForm();
    const offsetValueFromForm = Form.useWatch('heaterMcOffset', form);
    const children = props.children;
    const [popoverOpen, setPopoverOpen] = React.useState(false);

    // @ts-ignore
    const handleTriggerClick = (e, childOnClick) => {
        // Call the child's original onClick if it has one
        if (childOnClick) {
            childOnClick(e);
        }
    };

    // Clone the trigger element
    // @ts-ignore
    const trigger = React.cloneElement(children!, {
    // @ts-ignore
        onClick: (e) => handleTriggerClick(e, children?.props?.onClick),
    });

    const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      setPopoverOpen(false);
    }
  };

  useEffect(() => {
    if (popoverOpen) {
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
    }

    // Cleanup
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [popoverOpen]);

    const handleApply = () => {
        form.submit();
    };

    

    return (
        <Popover trigger="click" destroyOnHidden title={<Space direction="horizontal" size={4}><Typography.Text>Heater Settings</Typography.Text>
        <HeaterSettingsHelpTextTooltip binDTO={props.binDTO} heaterOffset={offsetValueFromForm ?? 5} />
</Space>}
            open={popoverOpen}
            onOpenChange={(desiredOpen) => {
                // check if the popup is needed
                const fanStatus = getDesiredFanMode(props.binDTO);

                console.log("popup change:", { desiredOpen, fanStatus });

                if (props.disabled) {
                    setPopoverOpen(false);
                    return;
                }

                if (desiredOpen === true && fanStatus === ManualFanMode.AutoWeather) {
                    setPopoverOpen(desiredOpen)
                }
                else if (desiredOpen === true) {
                    setPopoverOpen(false);
                    //skip settings, go straight to turning on the heater since the fans ignore weather conditions in always on mode
                    mutateHeaterMode.mutate({
                        heaterDesiredOn: true,
                    });
                }
                else {
                    setPopoverOpen(false);
                }
            }
            }
            content={<>
                <Form initialValues={{
                    heaterMcOffset: (props.binDTO?.weatherMonitorState?.heaterPlenumMcOffset ?? 5),
                }} form={form} id="test" onFinish={(vals) => {
                    console.log("heater emc update clicked");
                    updateHeaterMcOffsetMutation.mutate({ heaterMcOffset: vals.heaterMcOffset }, {
                        onSuccess(data, variables, context) {
                            if (data.success) {
                                message.success("Heater EMC Offset applying...");
                                mutateHeaterMode.mutate({
                                    heaterDesiredOn: true,
                                }, {
                                    onSuccess(data, variables, context) {
                                        if (data.success) {
                                            message.success("Heater Mode set to ON");
                                            setPopoverOpen(false);
                                        }
                                        else {
                                            message.error("Problem setting Heater Mode to ON");
                                        }
                                    },
                                    onError(error, variables, context) {
                                        console.error("Error setting Heater Mode to ON", error);
                                        message.error("Error setting Heater Mode to ON");
                                    },
                                });
                            }
                            else {
                                message.error("Problem setting heater EMC Offset");
                            }
                        },
                        onError(error, variables, context) {
                            console.error("Error applying heater EMC Offset", error);
                            message.error("Error applying heater EMC Offset");
                        },
                    });
                }}>
                    <Form.Item name="heaterMcOffset" label="Heater EMC Offset"
                        rules={[
                            {
                                type: 'number',
                                max: 20,
                                message: 'Max is 20%',
                            }
                        ]}
                    >
                        <InputNumber addonAfter="%" />
                    </Form.Item>
                </Form>

                <br />
                <Alert type="info" icon={null} message={<FormatHeaterOffsetHelpShortText binDTO={props.binDTO!} newOffset={offsetValueFromForm} />} />

                <div style={{ marginTop: 8, display: "flex", justifyContent: "flex-end", gap: 8 }}>
                    <Button onClick={() => setPopoverOpen(false)}>
                        Cancel
                    </Button>
                    <Button type="primary" loading={updateHeaterMcOffsetMutation.isLoading || mutateHeaterMode.isLoading} onClick={handleApply}>
                        Apply
                    </Button>
                </div>
            </>
            }>
            {trigger}
        </Popover>
    );
}